export const ARCHIVED_APPOINTMENTS = 'archived'
export const NEXT_APPOINTMENTS = 'next'
